const API_URL = process.env.VUE_APP_ENDPOINT_API;
import axios from 'axios';
import { authHeaders, getBearerToken } from '@/services/session.js';

class authService {

    login (data) {
        return new Promise((resolve, reject) => {
            axios({
                url: API_URL + 'tokens',
                method: 'POST',
                data
            }).then(resp => {
                resolve(resp)
            })
            .catch(err => {
                const data = err && err.response && err.response.data;
                reject((data && data.message) || (err && err.message) || 'Error al iniciar sesión')
            })
        })
    }

    user () {
        return new Promise((resolve, reject) => {
            if (!getBearerToken()) {
                reject(new Error('NO_SESSION'));
                return;
            }
            axios({
                url: API_URL + 'tokens/user',
                method: 'POST',
                headers: authHeaders()
            }).then(resp => {
                resolve(resp)
            })
            .catch(err => {
                reject(err)
            })
        })
    }
}

export default new authService ()
